import script from "./ProgressRing.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressRing.vue?vue&type=script&setup=true&lang=js"

import "./ProgressRing.vue?vue&type=style&index=0&id=0c2f38e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c2f38e8"]])

export default __exports__